"use client";

import { useState, useEffect } from "react";
import { SmoothScrollProvider } from "@/components/homepage/providers/SmoothScrollProvider";
import { BlobCursor } from "@/components/homepage/interactions/BlobCursor";
import { ChapterDots } from "@/components/homepage/ui/ChapterDots";
import { HeroSection } from "@/components/homepage/sections/HeroSection";
import { ProblemSection } from "@/components/homepage/sections/ProblemSection";
import { SolutionSection } from "@/components/homepage/sections/SolutionSection";
import { FeaturesSection } from "@/components/homepage/sections/FeaturesSection";
import { DemoSection } from "@/components/homepage/sections/DemoSection";
import { CTASection } from "@/components/homepage/sections/CTASection";
import { useReducedMotion } from "@/hooks/useReducedMotion";

const chapters = [
  { id: "hero", label: "Hero" },
  { id: "problem", label: "Problem" },
  { id: "solution", label: "Solution" },
  { id: "features", label: "Features" },
  { id: "demo", label: "Demo" },
  { id: "cta", label: "Get Started" },
];

export default function HomePage() {
  const reducedMotion = useReducedMotion();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Show a minimal loading state until client-side hydration is complete
  if (!mounted) {
    return (
      <main className="min-h-screen bg-[#252423] text-[#DAD5D0]">
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-pulse text-2xl font-bold tracking-widest">VIBE</div>
        </div>
      </main>
    );
  }

  return (
    <SmoothScrollProvider disabled={reducedMotion}>
      <main className="min-h-screen bg-[#252423] text-[#DAD5D0] selection:bg-[#DAD5D0]/20 font-sans overflow-x-hidden max-w-[100vw]">
        {/* Blob cursor effect (desktop only) */}
        <BlobCursor color="#8b5cf6" size={350} opacity={0.25} />

        {/* Chapter navigation dots */}
        <ChapterDots chapters={chapters} />

        {/* Sections */}
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <FeaturesSection />
        <DemoSection />
        <CTASection />
      </main>
    </SmoothScrollProvider>
  );
}
